import { connectComponent } from "@tm/morpheus"
import { PanelSection } from "@tm/controls"
import { useLocalization } from "@tm/localization"
import { useMemo } from "react"
import { ErpIconType } from "@tm/models"
import { DetailsFrameState, Actions } from "./business"

type Props = {
    state: DetailsFrameState
    url: string
    id: string
    title?: string | number
}

function DetailsFrameComponent(props: Props) {
    const { detailsResponse: { article } = {}, erpResponse: { specialIcons } = {} } = props.state
    const { translateText, language } = useLocalization()

    const url = useMemo(() => {
        if (!article) {
            return null
        }

        const { traderArticleNo } = article
        let result = props.url

        /** Please change the way we get the tab informations from the SVC, as soon we get another "exception" for this case!!! */
        if (props.id === "safety-data-sheet" && specialIcons) {
            const safetySpecialIcon = specialIcons.find((x) => x.type === ErpIconType.SafetyDataSheets)
            if (safetySpecialIcon?.linkUrl) {
                result = safetySpecialIcon.linkUrl
            }
        }

        result = result.replace("{#traderArticleNo}", traderArticleNo || "")
        result = result.replace("{#traderArticleNo:noWhitespace}", traderArticleNo ? traderArticleNo.replace(/ /g, "") : "")
        result = result.replace("{#language}", language)
        return result
    }, [article, language, props.id, props.url, specialIcons])

    if (!url) {
        return null
    }

    return (
        <PanelSection className="article-details__frame" title={props.title && translateText(props.title)}>
            <iframe className="article-details__frame__control" src={url} id={`article-details__frame__${props.id}`} />
        </PanelSection>
    )
}

export default connectComponent(Actions, DetailsFrameComponent)
